
import React from 'react';
import { generateResponsiveImageSets } from './srcsetUtils';

/**
 * ResponsiveImage React component
 */
export function ResponsiveImage({
  src,
  alt,
  width,
  height,
  className,
  sizes,
  loading = 'lazy',
  widths = [320, 640, 768, 1024, 1280, 1536],
  objectPosition = 'center', // Added object-position support
}: {
  src: string;
  alt: string;
  width?: number;
  height?: number;
  className?: string;
  sizes?: string;
  loading?: 'lazy' | 'eager';
  widths?: number[];
  objectPosition?: 'top' | 'center' | 'bottom'; // New prop
}): React.ReactElement {
  const { srcset, webpSrcset, fallback } = generateResponsiveImageSets(src, widths);

  const sizesAttr = sizes || '(min-width: 1280px) 33vw, (min-width: 768px) 50vw, 100vw';
  
  // Generate object position class
  const objectPositionClass = `object-${objectPosition}`;

  return (
    <picture>
      <source srcSet={webpSrcset} type="image/webp" sizes={sizesAttr} />
      <source srcSet={srcset} sizes={sizesAttr} />
      <img
        src={fallback}
        alt={alt}
        width={width}
        height={height}
        className={`${className} ${objectPositionClass}`}
        loading={loading}
        decoding="async"
        onError={(e) => {
          const target = e.target as HTMLImageElement;
          console.error(`Failed to load image: ${target.src}`);
        }}
      />
    </picture>
  );
}
